import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'
import useNavData from '../../cmsHooks/useNavData'

import ContentContainer from '../layout/ContentContainer'
import device from '../../utilities/device'

const NavContainer = styled.nav`
  width: 100%;
  position: sticky;
  background-color: white;
  z-index: 10;
  top: 0;
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.25);
`
const Layout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`
const LinksContainer = styled.div`
  a {
    color: ${({ theme }) => theme.colorDarkBlue};
    &.active {
      font-weight: 600;
    }
  }
  a:not(:last-child) {
    margin-right: 20px;
  }
  @media ${device.mobileL} {
    margin-left: 20px;
    a {
      font-size: 16px;
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }
`

const Nav = () => {
  const data = useNavData()

  return (
    <NavContainer>
      <ContentContainer verticalPadding={'20px'}>
        <Layout>
          <Link to="/">
            <CMS.Image data={data} name={'Logo'} />
          </Link>
          <LinksContainer>
            <Link to="/about" activeClassName="active">
              <CMS.Text data={data} name={'About link'} />
            </Link>
            <Link to="/contact" activeClassName="active">
              <CMS.Text data={data} name={'Contact link'} />
            </Link>
          </LinksContainer>
        </Layout>
      </ContentContainer>
    </NavContainer>
  )
}

export default Nav
